<script setup lang="ts">
  import type { IconComponent } from '@gat-ship/icons'

  // Presentational empty state for port detail sections whose backend isn't in
  // place yet (Terminals, Berths, Anchorages). Rendered inline by the modal with
  // a per-section icon/title so the three sections don't each need a near-
  // identical view file (which fallow would flag as a clone).
  defineProps<{
    icon: IconComponent
    title: string
    description: string
  }>()
</script>

<template>
  <div
    class="text-muted-foreground mx-auto flex max-w-sm flex-col items-center gap-3 p-10 text-center"
  >
    <component :is="icon" class="size-8 opacity-60" />
    <div class="text-foreground text-sm font-medium">{{ title }}</div>
    <div class="text-sm">{{ description }}</div>
  </div>
</template>
